import { root } from './validate';

export const validate = {
  ...root,
};
